var path = '/modules/bo/components/al-bo-preview/component.tpl.html';
var html = "<div class=\"al-bo-preview\">\n    <div ng-if=\"vm.boInformation.length === 0 && !vm.loading\">\n        <strong>{{ 'bo.components.al-bo-preview.nothing-booked' | translate }}</strong>\n    </div>\n    <div ng-repeat=\"objectInformation in vm.boInformation\" ng-if=\"!vm.loading && vm.shouldDisplay(objectInformation)\">\n        <ng-include src=\"vm.typeTemplates[objectInformation.object.type]\"></ng-include>\n    </div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/bo/components/al-bo-preview/component.tpl.html
// module id = 2054
// module chunks = 1